import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styleMobile = StyleSheet.create({
  wrapper: {
    height: 230,
    width: 265,
    alignItems: 'center',
  },
  image: {
    borderRadius: 24,
    borderWidth: 2,
    borderColor: neutrals.white,
    position: 'absolute',
  },
});
const styleOneImageMobile = [
  StyleSheet.create({
    photo: {
      width: 230,
      height: 230,
    },
  }),
];
const styleTwoImageMobile = [
  StyleSheet.create({
    photo: {
      width: 161,
      height: 161,
      right: 3,
      top: 3,
      zIndex: 0,
      transform: [{ rotate: '8deg' }],
    },
  }),
  StyleSheet.create({
    photo: {
      width: 138,
      height: 138,
      left: 5,
      bottom: 5,
      zIndex: 1,
      transform: [{ rotate: '-14deg' }],
    },
  }),
];
const styleThreeImageMobile = [
  StyleSheet.create({
    photo: {
      width: 161,
      height: 161,
      right: 3,
      top: 3,
      zIndex: 0,
      transform: [{ rotate: '8deg' }],
    },
  }),
  StyleSheet.create({
    photo: {
      width: 138,
      height: 138,
      left: 5,
      top: 35,
      zIndex: 1,
      transform: [{ rotate: '-14deg' }],
    },
  }),
  StyleSheet.create({
    photo: {
      width: 115,
      height: 115,
      bottom: 2,
      right: 54,
      zIndex: 2,
      transform: [{ rotate: '4deg' }],
    },
  }),
];

export const styleDesktop = StyleSheet.create({
  wrapper: {
    flex: 1,
    height: 100,
  },
  image: {
    borderRadius: 8,
    borderWidth: 2,
    borderColor: neutrals.white,
    position: 'absolute',
  },
});
const styleOneImageDesktop = [
  StyleSheet.create({
    photo: {
      width: 100,
      height: 100,
    },
  }),
];
const styleTwoImageDesktop = [
  StyleSheet.create({
    photo: {
      width: 70,
      height: 70,
      right: 3,
      top: 3,
      zIndex: 0,
      transform: [{ rotate: '8deg' }],
    },
  }),
  StyleSheet.create({
    photo: {
      width: 60,
      height: 60,
      left: 5,
      bottom: 5,
      zIndex: 1,
      transform: [{ rotate: '-14deg' }],
    },
  }),
];
const styleThreeImageDesktop = [
  StyleSheet.create({
    photo: {
      width: 70,
      height: 70,
      right: 3,
      top: 3,
      zIndex: 0,
      transform: [{ rotate: '8deg' }],
    },
  }),
  StyleSheet.create({
    photo: {
      width: 60,
      height: 60,
      left: 5,
      top: 15,
      zIndex: 1,
      transform: [{ rotate: '-14deg' }],
    },
  }),
  StyleSheet.create({
    photo: {
      width: 50,
      height: 50,
      bottom: 2,
      right: 24,
      zIndex: 2,
      transform: [{ rotate: '4deg' }],
    },
  }),
];

export const styleMobileImage = [styleOneImageMobile, styleTwoImageMobile, styleThreeImageMobile];
export const styleDesktopImage = [styleOneImageDesktop, styleTwoImageDesktop, styleThreeImageDesktop];
